import React from 'react';
import { Tick } from './styled';

export default function TickAnimation(props) {
  const { pincode, stateTick } = props;
  return (
    <Tick pincode={pincode} stateTick={stateTick}>
      <img src="/images/greenticksvg.svg" alt="greentick" />
    </Tick>
  );
}
